import React, { useEffect, useRef } from "react";
import { BroadcastService } from "@microsoft/omnichannel-chat-components";
export const AudioNotificationStateful = props => {
  const {
    audioSrc,
    isAudioMuted
  } = props;
  const audioRef = useRef(new Audio(audioSrc));
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    BroadcastService.getMessageByEventName("NewMessageNotification").subscribe(msg => {
      audioRef.current.play();
    });
  }, []);
  useEffect(() => {
    isAudioMuted ? audioRef.current.muted = true : audioRef.current.muted = false;
  }, [isAudioMuted]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default AudioNotificationStateful;